export default __webpack_public_path__ + "static/media/logo-mandiri.0a80229c.jpg";